/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { htmlspecialchars } from './util.js';
import { closeAllTooltips } from './page-tooltips.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';


export let mjWidgetOverlayEditor = function($) {

	var m_cur_elem = null,
		m_cur_overlay = null,
		m_overlay_css_width = null,
		m_overlay_css_class = null,
		m_offset_parent = null,
		m_close_with_cb = null;

	var m_global_offset = false;

	function _destroy() {
		$(document).off('.mjWidgetOverlayEditor');
		m_cur_elem = null;
		if( m_cur_overlay!==null ) {
			m_cur_overlay.remove();
			m_cur_overlay = null;
		}
		m_offset_parent = null;
	}

	function _offset_parent() {
		if( m_offset_parent===null ) m_offset_parent = m_cur_elem===null ? null : m_cur_elem.offsetParent();
		return m_offset_parent;
	}

	function _reposition( offs_parent ) {
		var opsl = offs_parent.scrollLeft(),
			opst = offs_parent.scrollTop(),
			p = m_global_offset ? m_cur_elem.offset() : m_cur_elem.position(),
			x = p.left + 9 + 5 + opsl,
			y = p.top + 9 + opst,
			w = m_overlay_css_width===null ? m_cur_elem.width() : 0;
		var ctn = m_cur_elem.prop('tagName');
		if( ctn==='TEXTAREA' ) {
			// for <TEXTAREA ..>
		} else if( ctn==='INPUT' ) {
			// for <INPUT type="text" ..>
			x = x - 10;
			y = y + (m_cur_elem.height()||0) - 3;
			w = w + 90;
		} else {
			// for anything else (e.g. SPAN, A, etc...)
			x = x - 10;
			y = y + (m_cur_elem.height()||0) - 9;
			w = w + 160;
		}
		m_cur_overlay.css( { left:x+'px', top:y+'px', width:m_overlay_css_width===null?(w+'px'):m_overlay_css_width } );
	}

	function _reposition_fix( elem ) {
		if( m_cur_elem===null ) return; // called after this overlay was closed already
		var offs_parent = _offset_parent(),
			opsl = offs_parent.scrollLeft(),
			p = m_global_offset ? m_cur_elem.offset() : m_cur_elem.position(),
			o = m_cur_elem.offset(),
			x = p.left + 9 + 5 + opsl,
			opw = offs_parent.width(),
			w = m_cur_elem.width();

		if( x>0 && x+w >= opw-10 ) {
			x = x - (opw-10) - w;
			if( x+(o.left-p.left) < 0 ) x = 0;
			m_cur_overlay.css('left',x+'px');
		}

		var opst = offs_parent.scrollTop(),
			oph = offs_parent.height()||0,
			h = m_cur_elem.height()||0,
			oh = m_cur_overlay.height()||0,
			y = p.top + 9 + opst;

		// to avoid visible jumping, use the formulas from _reposition() ...
		var ctn = m_cur_elem.prop('tagName');
		if( ctn==='TEXTAREA' ) {
			// ?
		} else if( ctn==='INPUT' ) {
			y = y + h - 3;
		} else {
			y = y + h - 9;
		}
		if( y>0 && (y+oh-opst) >= (oph-10) ) {
			y = (oph-10)+opst - oh;
		}
		var ymin = 10;
		if( (y-opst) < ymin ) {
			y = ymin + opst;
		}
		m_cur_overlay.css('top',y+'px');
	}

	function _overlay() {
		$('#mj-widget-overlay').remove();
		var offs_parent = _offset_parent();
		m_cur_overlay = $('<div id="mj-widget-overlay" style="display:none"></div>').appendTo(offs_parent);
		if( m_overlay_css_class ) m_cur_overlay.addClass(m_overlay_css_class);
		_reposition(offs_parent);
		return m_cur_overlay;
	}

	function close() {
		if( m_close_with_cb ) m_close_with_cb();
		_destroy();
	}

	function isOpen( elem ) {
		if( m_cur_overlay && m_cur_overlay.is(':visible') ) {
			if( elem ) return m_cur_elem[0] === elem[0];
			return true;
		}
		return false;
	}

	function open( elem, val, setup_cb, extract_cb, accept_cb, close_cb, options ) {
		var thisWidget = this;
		_destroy();
		m_cur_elem = elem;

		// some options
		var ok_btn_text, cancel_btn_text, wrap_overlay_contents;
		m_overlay_css_width = options && options.hasOwnProperty('OverlayCssWidth') ? options.OverlayCssWidth : null;
		ok_btn_text = options && options.hasOwnProperty('OkButtonText') ? options.OkButtonText : mjt('ok');
		cancel_btn_text = options && options.hasOwnProperty('CancelButtonText') ? options.CancelButtonText : mjt('cancel');
		m_offset_parent = options && options.hasOwnProperty('OffsetParent') ? options.OffsetParent : null;
		m_global_offset = options && options.hasOwnProperty('GlobalOffset') ? !!options.GlobalOffset : false;
		m_overlay_css_class = options && options.hasOwnProperty('OverlayCssClass') ? options.OverlayCssClass : null;
		wrap_overlay_contents = options && options.hasOwnProperty('WrapOverlayContents') ? !!options.WrapOverlayContents : true;

		// create overlay
		var ovl = _overlay();
		let ok_button = ovl.find('button.x-ok');

		// extended interface to overlay ..
		const xcallbacks = {
			get_ok_button: function() {
				return ovl.find('button.x-ok');
			},
			get_cancel_button: function() {
				return ovl.find('button.x-cancel');
			}
		};
		setup_cb.call(this,m_cur_elem,val,ovl,xcallbacks);

		if( wrap_overlay_contents ) ovl.wrapInner('<div class="mj-widgets"></div>');

		function _apply() {
			var out = extract_cb ? extract_cb.call(thisWidget,ovl) : null;
			close();
			if( accept_cb ) accept_cb.call(thisWidget,out,val);
		}
		function _close(e) {
			if( close_cb ) close_cb.call(thisWidget,elem);
			m_close_with_cb = null;
			close();
			if( e ) e.preventDefault();
		}
		m_close_with_cb = _close;

		var actions_div = $('<div class="mj-actions"></div>').appendTo(ovl);
		var ovl_ok_btn = null;
		if( ok_btn_text ) ovl_ok_btn = $('<button class="small x-ok" type="button"><span class="left"></span><span class="label">'+htmlspecialchars(ok_btn_text)+'</span><span class="right"></span></button>').click(_apply).appendTo(actions_div);
		var ovl_cancel_btn = null;
		if( cancel_btn_text ) ovl_cancel_btn = $('<button class="small x-cancel" type="button"><span class="left"></span><span class="label">'+htmlspecialchars(cancel_btn_text)+'</span><span class="right"></span></button>').click(_close).appendTo(actions_div);

		// keyboard events
		ovl.on( 'keydown.mjWidgetOverlayEditor', function(e) {
			switch( e.which ) {
			case  9:	// TAB
				var inputs = ovl.find(':input').not('input[type=hidden]');
				if( e.shiftKey ) {
					if( inputs.first().is(':focus') ) {
						e.preventDefault();
						e.stopPropagation();
						if( ovl_cancel_btn===null ) {
							// cycle from first input to OK button
							if( ovl_ok_btn!==null ) ovl_ok_btn.focus();
						} else {
							// cycle from first input to CANCEL button
							ovl_cancel_btn.focus();
						}
					}
				} else if( ovl_ok_btn!==null && ovl_ok_btn.is(':focus') ) {
					e.preventDefault();
					e.stopPropagation();
					if( ovl_cancel_btn===null ) {
						// cycle from OK button to first input
						inputs.first().focus();
					} else {
						ovl_cancel_btn.focus();
					}
				} else if( ovl_cancel_btn!==null && ovl_cancel_btn.is(':focus') ) {
					e.preventDefault();
					e.stopPropagation();
					// cycle from CANCEL button to first input
					inputs.first().focus();
				}
				break;
			case 13:	// ENTER
				var ofe = ovl.find(':focus');
				if( ofe.length===0 ) break;
				var oftn = ofe[0].tagName;
				if( oftn==='INPUT' ) {
					e.preventDefault();
					e.stopPropagation();
					_apply();
				} else if( oftn==='SELECT' ) {
					e.preventDefault();
					e.stopPropagation();
					_apply();
				} else if( oftn==='TEXTAREA' ) {
					if( e.ctrlKey || e.metaKey || e.shiftKey ) {
						// shift/ctrl/alt + ENTER = Save
						e.preventDefault();
						e.stopPropagation();
						_apply();
					}
				}
				break;
			case 27:	// ESCAPE
				if( !e.isDefaultPrevented() ) {
					e.preventDefault();
					e.stopPropagation();
					_close(e);
				}
				return false;
			}
		} );

		// close tooltips (could be visible on top of new overlay, which would be disturbing)
		closeAllTooltips();

		// show & select value of first input
		ovl.show();
		_reposition_fix(ovl);

		ovl.fadeIn( 'fast', function() {

			_reposition_fix(ovl);
			ovl.find(':input').not('input[type=hidden]').filter(':visible').first()
				.focus()		// for checkboxes, radioboxes, select elements
			;
			function on_doc_mouse_event_handler(e) {

				var t = $(e.target);
				if( t.closest('#mj-widget-overlay').length ) {
					// click inside '#mj-widget-overlay' -> dont do anything







				} else if( t.closest('.select2-container').length ) {
					// click inside of some select2 container overlay -> dont do anything
				} else if( t.closest('.colorpicker').length ) {
					// click inside of some colorpicker overlay -> dont do anything
				} else if( $('.colorpicker').filter(':visible').length ) {
					// some colorpicker overlay is active -> dont do anything here
				} else if( !$.contains(document.documentElement,e.target) ) {	//if( !document.contains(e.target) ) {

				} else {
					// click outside of '#mj-widget-overlay' -> close() = CANCEL edit
					_close(e);


				}
			}


			window.setImmediate( function() {
				// any click on outside of widget should close overlay ...
				$(document)
					.off('.mjWidgetOverlayEditor')
					.on('click.mjWidgetOverlayEditor',on_doc_mouse_event_handler)
					.on('mousedown.mjWidgetOverlayEditor',on_doc_mouse_event_handler);
			} );


			if( options && options.OnShow ) options.OnShow(ovl,xcallbacks);
		} );
	}

	return {
		open: open,
		close: close,
		isOpen: isOpen,
	};

}(jQuery); // namespace mjWidgetOverlayEditor
